export const tabContentVariant = {
  active: {
    display: "block",
    transition: {
      staggerChildren: 0.2,
    },
  },
  inactive: {
    display: "none",
  },
};

export const sideCardVariants = {
  inactive: {
    x: 0,
    opacity: 1,
    transition: {
      duration: 0.4,
    },
  },
  active: {
    x: -250,
    opacity: 1,
    transition: {
      duration: 1,
    },
  },
};
